import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { updateClaimType, deleteDocTypeAll } from '../reducers/formActions';
import ContactRefNo from './ContactRefNo'
import CurrencyInput from 'react-currency-input-field';
import Swal from 'sweetalert2'
import * as numeral from 'numeral'
import { api } from '../utils/endpoint.js'

import iconClaim from '../images/step2/ic_claim.svg'
import iconQuotation from '../images/step2/ic_quotation.svg'
import iconIDCard from '../images/step2/ic_id_card.svg'
import iconPicOfDamage from '../images/step2/ic_pic_of_damage.svg'
import iconVehicleRegister from '../images/step2/ic_vehical_register.svg'
import iconIDCardAuthorized from '../images/step2/ic_id_card_authorized.svg'
import iconPowerOfAttorney from '../images/step2/ic_power_of_attorney.svg'
import iconAct from '../images/step2/ic_act.svg'
import iconInsurancePolicy from '../images/step2/ic_insurance_policy.svg'
import iconRecipet from '../images/step2/ic_reciept.svg'
import iconCarDump from '../images/step2/ic_car_dump.svg'
import iconDoc from '../images/step2/ic_doc.svg'
import iconCoppy from '../images/summary/ic_coppy.svg'

import iconIDCardParty from '../images/step2/ic_id_card_party.svg'
import iconRegistrationCertificate from '../images/step2/ic_registration_certificate.svg'


import iconRequire from '../images/step2/ic_require.svg'
import iconNotRequire from '../images/step2/ic_not_require.svg'

import iconFile from '../images/step2/ic_file.svg'
import iconUpload from '../images/step2/ic_upload.svg'
import formTypes from '../reducers/formTypes';

import iconSuccessAlert from '../images/alert/ic_alert_success.svg'
import iconCloseAlert from '../images/alert/ic_close.svg'

import iconDropDown from '../images/dropdown/ic_dropdown.svg'
import iconDropDownChecked from '../images/dropdown/ic_dropdown_checked.svg'
import { CLAIM_TYPES, CLAIM_TYPE } from '../utils/claim-type'

function Step2(props) {
  let onSuccess = props.onSuccess

  const [ isEnableNewStep, setIsEnableNewStep ] = useState(false  )
  let onSelectedFile = props.onSelectedFile
  const [ documentType, setDocuentType ] = useState(
     ( props.claim_info.type === undefined || props.claim_info.type === '' )? null : props.claim_info.type
    ) 
  let [ defaultHover, setDefaultHover ] = useState({
    doc1 : false,
    doc2 : false,
    doc3 : false,
    doc4 : false,
    doc5 : false,
    doc6 : false,
    doc7 : false,
    doc8 : false,
    doc9 : false,
    doc10 : false,
    doc11 : false,
    doc12 : false,
    doc13 : false,
    doc14 : false,
    doc15 : false,
    doc16 : false,
    doc17 : false,
    doc18 : false,
    doc19 : false,
    doc20 : false,
    doc21 : false,
  })
  let [ hoverState, setHoverState ] = useState(defaultHover)


  const [ isShowDropDown, setIsShowDropDown ] = useState(false)

  const [ isMobileSize, setIsMobileSize ] = useState(window.innerWidth <= 425 ? true:false)

  const [ isStateDelete, setIsStateDelete ]= useState(false)
  const [ fileList, setFileList ] = useState([])
  const [ documents, setDocuments ] = useState(
    [
      {
        id : 1,
        name : "ใบเคลม",
        nameMobile : "ใบเคลม",
        description : "หรือ ต้นฉบับหลักฐานรับผิดชอบ\nความเสียหายรถประกัน",
        descriptionMobile : "หรือ ต้นฉบับหลักฐานรับ\nผิดชอบความเสียหายรถประกัน",
        icon : iconClaim,
        is_required : true,
        is_signatured : false
      },
      {
        id : 2,
        name : "ใบเสนอราคา",
        nameMobile : "ใบเสนอราคา",
        description : "หรือคุณสามารถใช้ใบเสร็จแทนได้",
        descriptionMobile : "หรือคุณสามารถใช้ใบเสร็จแทนได้",
        icon : iconQuotation,
        is_required : true,
        is_signatured : false
      },
      {
        id : 3,
        name : "รูปภาพความเสียหาย",
        nameMobile : "รูปภาพ\nความเสียหาย",
        description : "กรุณาแสดงภาพความเสียหาย\nรวมถึงส่วนที่เกี่ยวข้อง",
        descriptionMobile : "กรุณาแสดงภาพความ\nเสียหายรวมถึงส่วนที่เกี่ยวข้อง",
        icon : iconPicOfDamage,
        is_required : true,
        is_signatured : false
      },
      {
        id : 4,
        name : "สำเนาบัตรประชาชนคู่กรณี",
        nameMobile : "สำเนา\nบัตรประชาชนคู่กรณี",
        description : "",
        descriptionMobile : "",
        icon : iconIDCardParty,
        is_required : true,
        is_signatured : true
      },
      {
        id : 5,
        name : "สำเนาบัตรประชาชน\nผู้เอาประกันภัย",
        nameMobile : "สำเนาบัตรประชาชน\nผู้เอาประกันภัย",
        description : "",
        descriptionMobile : "",
        icon : iconIDCard,
        is_required : true,
        is_signatured : true
      },
      {
        id : 6,
        name : "หนังสือมอบอำนาจ",
        nameMobile : "หนังสือมอบอำนาจ",
        description : "พร้อมสำเนาบัตรประชาชน\nและติดอากรสแตมป์ 30 บาท",
        descriptionMobile : "พร้อมสำเนาบัตรประชาชน\nและติดอากรสแตมป์ 30 บาท",
        icon : iconPowerOfAttorney,
        is_required : true,
        is_signatured : false
      },
      {
        id : 7,
        name : "สำเนาบัตรประชาชน\nผู้มอบอำนาจ",
        nameMobile : "สำเนาบัตรประชาชน\nผู้มอบอำนาจ",
        description : "",
        descriptionMobile : "",
        icon : iconIDCardAuthorized,
        is_required : true,
        is_signatured : true
      },
      {
        id : 8,
        name : "สำเนาหนังสือรับรอง\nการจดทะเบียน",
        nameMobile : "สำเนาหนังสือรับรอง\nการจดทะเบียน",
        description : "พร้อมสำเนาบัตรประชาชนกรรมการ",
        descriptionMobile : "พร้อมสำเนาบัตรประชาชนกรรมการ",
        icon : iconRegistrationCertificate,
        is_required : true,
        is_signatured : true
      },
      {
        id : 9,
        name : "ต้นฉบับคู่มือจดทะเบียนรถ",
        nameMobile : "ต้นฉบับ\nคู่มือจดทะเบียนรถ",
        description : "หรือสำเนา และรายการจดทะเบียน\nเปลี่ยนแปลง และรายการต่อภาษีปีปัจจุบัน",
        descriptionMobile : "หรือสำเนา และรายการจดทะเบียน\nเปลี่ยนแปลง และรายการต่อภาษีปีปัจจุบัน",
        icon : iconVehicleRegister,
        is_required : false,
        is_signatured : true
      },
      {
        id : 10,
        name : "สำเนากรมธรรม์ พรบ.",
        nameMobile : "สำเนา\nกรมธรรม์ พรบ.",
        description : "",
        descriptionMobile : "",
        icon : iconAct,
        is_required : false,
        is_signatured : false
      },
      {
        id : 11,
        name : "สำเนากรมธรรม์ประกันภัย\nภาคสมัครใจ",
        nameMobile : "สำเนา\nกรมธรรม์ประกันภัย\nภาคสมัครใจ",
        description : "",
        descriptionMobile : "",
        icon : iconInsurancePolicy,
        is_required : false,
        is_signatured : false
      },
      {
        id : 12,
        name : "ต้นฉบับใบเสร็จรับเงิน",
        nameMobile : "ต้นฉบับ\nใบเสร็จรับเงิน",
        description : "หรือ บิลเงินสดค่ารถยก",
        descriptionMobile : "หรือ บิลเงินสดค่ารถยก",
        icon : iconRecipet,
        is_required : true,
        is_signatured : false
      },
      {
        id : 13,
        name : "ภาพถ่ายขณะยกรถ",
        nameMobile : "ภาพถ่าย\nขณะยกรถ",
        description : "กรุณาแสดงภาพขณะยกรถ\nรวมถึงส่วนที่เกี่ยวข้อง",
        descriptionMobile : "กรุณาแสดงภาพขณะยกรถ\nรวมถึงส่วนที่เกี่ยวข้อง",
        icon : iconCarDump,
        is_required : true,
        is_signatured : false
      },
      {
        id : 14,
        name : "เอกสารเรียกร้อง\nค่าขาดประโยชน์",
        nameMobile : "เอกสารเรียกร้อง\nค่าขาดประโยชน์",
        description : "",
        descriptionMobile : "",
        icon : iconDoc,
        is_required : true,
        is_signatured : false
      },
      {
        id : 15,
        name : "ใบเคลม",
        nameMobile : "ใบเคลม",
        description : "หรือ สำเนาหลักฐานรับผิดชอบ\nความเสียหายรถคู่กรณี",
        descriptionMobile : "หรือ สำเนาหลักฐานรับผิดชอบ\nความเสียหายรถคู่กรณี",
        icon : iconClaim,
        is_required : true,
        is_signatured : false
      },
      {
        id : 16,
        name : "ใบเคลม",
        nameMobile : "ใบเคลม",
        description : "หรือ ต้นฉบับหลักฐานรับผิดชอบ\nความเสียหายรถคู่กรณี",
        descriptionMobile : "หรือ ต้นฉบับหลักฐานรับผิดชอบ\nความเสียหายรถคู่กรณี",
        icon : iconClaim,
        is_required : true,
        is_signatured : false
      },
      {
        id : 17,
        name : "ใบเสนอราคา",
        nameMobile : "ใบเสนอราคา",
        description : "",
        descriptionMobile : "",
        icon : iconQuotation,
        is_required : true,
        is_signatured : false
      },
      {
        id : 18,
        name : "ต้นฉบับใบเสร็จค่ารถยก",
        nameMobile : "ต้นฉบับ\nใบเสร็จค่ารถยก",
        description : "หรือ บิลเงินสดค่ารถยก",
        descriptionMobile : "หรือ บิลเงินสดค่ารถยก",
        icon : iconRecipet,
        is_required : true,
        is_signatured : false
      },
      {
        id : 19,
        name : "ใบเสนอราคา",
        nameMobile : "ใบเสนอราคา",
        description : "ต้นฉบับใบเสร็จค่ารถยก หรือ\nบิลเงินสดค่ารถยก​",
        descriptionMobile : "ต้นฉบับใบเสร็จค่ารถยก หรือ\nบิลเงินสดค่ารถยก​",
        icon : iconQuotation,
        is_required : true,
        is_signatured : false
      },
      {
        id : 20,
        name : "ภาพถ่ายความเสียหาย",
        nameMobile : "ภาพถ่าย\nความเสียหาย",
        description : "กรุณาแสดงภาพความเสียหาย\nรวมถึงส่วนที่เกี่ยวข้อง",
        descriptionMobile : "กรุณาแสดงภาพความเสียหาย\nรวมถึงส่วนที่เกี่ยวข้อง",
        icon : iconPicOfDamage,
        is_required : true,
        is_signatured : false
      },
      {
        id : 21,
        name : "ใบเคลม",
        nameMobile : "ใบเคลม",
        description : "หรือ สำเนาหลักฐานรับผิดชอบ\nความเสียหายรถประกัน",
        descriptionMobile : "หรือ สำเนาหลักฐานรับผิดชอบ\nความเสียหายรถประกัน",
        icon : iconClaim,
        is_required : true,
        is_signatured : false
      },
    ]
  )


  //รถประกัน หรือ คู่กรณี
  const [ suffererType, setSuffererType ] = useState(props.lisence_info.sufferer_type)
  //ประเภทผู้มาติดต่อ
  const [ contactType, setContactType ] = useState( props.contact_info.contact_type)
  //ผู้รับมอบอำนาจ
  const [ isAttorney, setIsAttorney ] = useState( props.contact_info.is_attorney )
  //ติดต่อในนามนิติ
  const [ isCompany, setIsCompany ] = useState( props.contact_info.is_company )

  const [ claimTypeList, setClaimTypeList ] = useState([] )

  const [ isShowLaborCost, setIsShowLaborCost ] = useState(false)
  const [ isShowAutoParts, setIsShowAutoParts ] = useState(false)
  const [ isShowLossOfBenefit, setIsShowLossOfBenefit ] = useState(false)
  const [ isShowTowCar, setIsShowTowCar ] = useState(false)

  const [ laborCost, setLaborCost ] = useState(props.contact_info.labor_cost) //ค่าแรง
  const [ autoParts, setAutoParts ] = useState(props.contact_info.auto_parts) //ค่าอะไหล่
  const [ lossOfBenefit, setLossOfBenefit ] = useState(props.contact_info.loss_of_benefit) //ค่าขาดผลประโยชน์
  const [ towCar, setTowCar ] = useState(props.contact_info.tow_car) //ค่ารถยก
  const [ totalCost, setTotalCost ] = useState(calculatetotalCost()) //รวมทั้งหมด

  const [ testIdFileList, setTestIdFileList ] = useState([
    '',
    'insuredDoc-claim-button', //1
    'contestantDoc-quotation-receipt-button',
    'insuredDoc-damagePhoto-button',
    'contestantDoc-copy-id-button',
    'insuredDoc-copy-id-button', //5
    'assignDoc-button',
    'attorneyDoc-copy-id-button',
    'corporationDoc-copy-button',
    'doc-vehicleRegistration-button',
    'contestantDoc-copy-cmi-button', //10
    'contestantDoc-copy-vmi-button',
    'insuredDoc-receipt-towCarBill-button',
    'insuredDoc-towCarPhoto-button',
    'contestantDoc-loseBenefits-button',
    'contestantDoc-copy-claim-button',//15
    'contestantDoc-claim-button',
    'insuredDoc-quotation-button',
    'contestantDoc-towCarReceipt-towCarBill-button',
    'contestantDoc-quotation-towCarReceipt-towCarBill-button',
    'contestantDoc-damagePhoto-button',//20
    'insuredDoc-copy-claim-button',
  ])



  useEffect(() => {

  }, [documentType])

   
  useEffect(() => {
  }, [props.claim_info.type])

  useEffect(() => {
    if (suffererType !== undefined) {
      setClaimTypeList(CLAIM_TYPES(suffererType))
      if (suffererType !== 0) {
        if (documentType === null) {
          setDocuentType( 6 )
        }
      } else {
        if (documentType === null) {
          setDocuentType( 1 )
        }
      }
     
    } else {
      setClaimTypeList(CLAIM_TYPES(0))
      setDocuentType(1)
    }
  }, [ suffererType ])

  useEffect(() => {
    const items = getFileList()
    setFileList(items)
  }, [ documentType ])


  useEffect(() => {
    window.scrollTo(0, 0)
    const items = getFileList()
    setFileList(items)
  }, [  ])

  useEffect(() => {
    checkSubmitAll()
  }, [ props.claim_info.docs, documentType ])

  
  useEffect(() => {
    const items = getFileList()
    setFileList(items)
  }, [ isStateDelete ])

  useEffect(() => {
    setTotalCost(calculatetotalCost())
  }, [ laborCost,autoParts,lossOfBenefit,towCar ])

  function onClickFile( tag ){
    onSelectedFile( tag )
  }

  function getFileList(){
    let docs = []
    // รถประกัน
    if (suffererType == '0') {
      if(documentType == "1") {
        // ค่าแรง ค่าอะไหล่ 
        docs.push( documents[0] )
        docs.push( documents[16] )
        docs.push( documents[2] )
        docs.push( documents[4] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
          
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[8] )

        setIsShowLaborCost(true)
        setIsShowAutoParts(true)
      } else if (documentType == "5") {
        // ค่าแรง ค่าอะไหล่ ค่ารถยก
        docs.push( documents[0] )
        docs.push( documents[16] )
        docs.push( documents[11] )
        docs.push( documents[2] )
        docs.push( documents[4] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[8] )

        setIsShowLaborCost(true)
        setIsShowAutoParts(true)
        setIsShowTowCar(true)
      } else if (documentType == "2") {
        // ค่ารถยก
        docs.push( documents[20] )
        docs.push( documents[16] )
        docs.push( documents[12] )
        docs.push( documents[4] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[8] )

        setIsShowTowCar(true)
      } else if (documentType == "3") {
        // ค่ายาง ค่าล้อแม็ก
        docs.push( documents[0] )
        docs.push( documents[16] )
        docs.push( documents[2] )
        docs.push( documents[4] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[8] )

        setIsShowLaborCost(true)
        setIsShowAutoParts(true)
      } else if (documentType == "4") {
        // ค่ากระจก ค่าฟิล์ม
        docs.push( documents[0] )
        docs.push( documents[16] )
        docs.push( documents[2] )
        docs.push( documents[4] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[8] )

        setIsShowLaborCost(true)
        setIsShowAutoParts(true)
      } 
    } else {
      if(documentType == "6") {
        // ค่าแรง ค่าอะไหล่ 
        docs.push( documents[15] )
        docs.push( documents[1] )
        docs.push( documents[19] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

        setIsShowLaborCost(true)
        setIsShowAutoParts(true)
      }
      else if(documentType == "7") {
        // ค่าแรง ค่าอะไหล่ ค่าขาดประโยชน์
        docs.push( documents[15] )
        docs.push( documents[1] )
        docs.push( documents[19] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

        setIsShowLaborCost(true)
        setIsShowAutoParts(true)
        setIsShowLossOfBenefit(true)
      }
      else if(documentType == "8") {
        // ค่าแรง ค่าอะไหล่ ค่าขาดประโยชน์ ค่ารถยก
        docs.push( documents[15] )
        docs.push( documents[1] )
        docs.push( documents[17] )
        docs.push( documents[19] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

        setIsShowLaborCost(true)
        setIsShowAutoParts(true)
        setIsShowLossOfBenefit(true)
        setIsShowTowCar(true)
      }
      else if(documentType == "9") {
        // ค่าขาดประโยชน์
        docs.push( documents[14] )
        docs.push( documents[13] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

        setIsShowLossOfBenefit(true)
      }
      else if(documentType == "10") {
        // ค่าขาดประโยชน์ ค่ารถยก
        docs.push( documents[14] )
        docs.push( documents[13] )
        docs.push( documents[18] )
        // docs.push( documents[11] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

        setIsShowLossOfBenefit(true)
        setIsShowTowCar(true)
      }
      else if(documentType == "11") {
        // ค่ารถยก
        docs.push( documents[14] )
        documents[8].is_required = true
        docs.push( documents[18] )
        docs.push( documents[8] )
        // docs.push( documents[11] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

        setIsShowTowCar(true)
      }
      else if(documentType == "13") {
        // ค่ายาง ค่าล้อแม็ก
        docs.push( documents[15] )
        docs.push( documents[1] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

        setIsShowLaborCost(true)
        setIsShowAutoParts(true)
      }
      else if(documentType == "12") {
        // ค่ากระจก ค่าฟิล์ม
        docs.push( documents[15] )
        docs.push( documents[1] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

        setIsShowLaborCost(true)
        setIsShowAutoParts(true)
      }
     
    }

    return docs;
  }

  function getFileListSize( docType ){
    switch(docType){
      case 1: return props.claim_info.docs.code_1.items.length;
      case 2: return props.claim_info.docs.code_2.items.length;
      case 3: return props.claim_info.docs.code_3.items.length;
      case 4: return props.claim_info.docs.code_4.items.length;
      case 5: return props.claim_info.docs.code_5.items.length;
      case 6: return props.claim_info.docs.code_6.items.length;
      case 7: return props.claim_info.docs.code_7.items.length;
      case 8: return props.claim_info.docs.code_8.items.length;
      case 9: return props.claim_info.docs.code_9.items.length;
      case 10: return props.claim_info.docs.code_10.items.length;
      case 11: return props.claim_info.docs.code_11.items.length;
      case 12: return props.claim_info.docs.code_12.items.length;
      case 13: return props.claim_info.docs.code_13.items.length;
      case 14: return props.claim_info.docs.code_14.items.length;
      case 15: return props.claim_info.docs.code_15.items.length;
      case 16: return props.claim_info.docs.code_16.items.length;
      case 17: return props.claim_info.docs.code_17.items.length;
      case 18: return props.claim_info.docs.code_18.items.length;
      case 19: return props.claim_info.docs.code_19.items.length;
      case 20: return props.claim_info.docs.code_20.items.length;
      case 21: return props.claim_info.docs.code_21.items.length;
      default:  return 0;
    }
  }


  function getFileListFirst( docType ){
    switch(docType){
      case 1: return props.claim_info.docs.code_1.items[0].path;
      case 2: return props.claim_info.docs.code_2.items[0].path;
      case 3: return props.claim_info.docs.code_3.items[0].path;
      case 4: return props.claim_info.docs.code_4.items[0].path;
      case 5: return props.claim_info.docs.code_5.items[0].path;
      case 6: return props.claim_info.docs.code_6.items[0].path;
      case 7: return props.claim_info.docs.code_7.items[0].path;
      case 8: return props.claim_info.docs.code_8.items[0].path;
      case 9: return props.claim_info.docs.code_9.items[0].path;
      case 10: return props.claim_info.docs.code_10.items[0].path;
      case 11: return props.claim_info.docs.code_11.items[0].path;
      case 12: return props.claim_info.docs.code_12.items[0].path;
      case 13: return props.claim_info.docs.code_13.items[0].path;
      case 14: return props.claim_info.docs.code_14.items[0].path;
      case 15: return props.claim_info.docs.code_15.items[0].path;
      case 16: return props.claim_info.docs.code_16.items[0].path;
      case 17: return props.claim_info.docs.code_17.items[0].path;
      case 18: return props.claim_info.docs.code_18.items[0].path;
      case 19: return props.claim_info.docs.code_19.items[0].path;
      case 20: return props.claim_info.docs.code_20.items[0].path;
      case 21: return props.claim_info.docs.code_21.items[0].path;
      default:  return null;
    }
  }

  function getHoverState(docType){
    switch(docType){
      case 1: return hoverState.doc1;
      case 2: return hoverState.doc2;
      case 3: return hoverState.doc3;
      case 4: return hoverState.doc4;
      case 5: return hoverState.doc5;
      case 6: return hoverState.doc6;
      case 7: return hoverState.doc7;
      case 8: return hoverState.doc8;
      case 9: return hoverState.doc9;
      case 10: return hoverState.doc10;
      case 11: return hoverState.doc11;
      case 12: return hoverState.doc12;
      case 13: return hoverState.doc13;
      case 14: return hoverState.doc14;
      case 15: return hoverState.doc15;
      case 16: return hoverState.doc16;
      case 17: return hoverState.doc17;
      case 18: return hoverState.doc18;
      case 19: return hoverState.doc19;
      case 20: return hoverState.doc20;
      case 21: return hoverState.doc21;
      default:  return false;
    }
  }


  function checkSubmitAll() {
    let docs = getFileList();
    let isValid = false
    for(let i = 0; i < docs.length; i++){
      let doc = docs[i]
      if(doc.is_required) {
  
        if(getFileListSize(doc.id) > 0){
          isValid = true
        }
        else {
          isValid = false
          break;
        }
      }
    }
    setIsEnableNewStep(isValid)
  }

  function showConfirm(){

    Swal.fire({
      title: '<div data-testid="popup-title-text" >ยืนยันการส่งเอกสาร</div>',
      html: '<div data-testid="popup-description-text" class="swal-content-message">คุณยืนยันค่าสินไหม 0.00 บาท '+'</div>',
      showCancelButton: true,
      confirmButtonColor: '#009640',
      confirmButtonText: '<span data-testid="confirm-button" class="">ตกลง</span>',
      cancelButtonText: '<span data-testid="cancel-button" class="">ยกเลิก</span>',
      cancelButtonColor: '#FFFFF',
      customClass: {
        popup:  'swal-content-step3 swal-contrainner-step3',
        content : 'swal-content-step3',
        icon: 'swal-warning-icon-content',
        title: 'swal-warning-title-step3',
        confirmButton: 'swal-success-confirm-step3',
        cancelButton: 'swal-warning-cancel-step3',
        actions: 'swal-warning-action-step3'
      }

    }).then((result) => {
      if (result.isConfirmed) {
        onSuccess(documentType, laborCost, autoParts, lossOfBenefit, towCar)
      }
    })
  }

  async function submit(){
    if(Number(totalCost ) <= 0){
      showConfirm()
    }else{
      onSuccess(documentType, laborCost, autoParts, lossOfBenefit, towCar)
    }
  }

  function isHasFile( id ){
    if(getFileListSize(id) > 0) {
      if(isStateDelete) {
        return false;
      }
      return true;
    }
    return false;
  }

  const [ isShowAlert, setIsShowAlert ] = useState(false)
  const timer = useRef(null);
  const [ counter, setCounter ] = useState(1);
  function showAlert(){
    setIsStateDelete(true)
    clearIntervalAlert()
    setIsShowAlert(true)
    setCounter(1)
    setAlertTimer()
  }
  function setAlertTimer(){
    timer.current = setInterval(() => {
      setCounter((v) => v + 1)
    }, 1000);
    return () => clearTimeout(timer.current);
  }
  useEffect(() => {
    if (counter >= 5){
      // confirm Remove
      setIsStateDelete(false)
      confirmRemove()
      clearIntervalAlert()
    }
  }, [counter]);
  function clearIntervalAlert(){
    clearInterval(timer.current);
    setIsShowAlert(false);
    setCounter(1)
  }
  async function confirmRemove(){
    await callApiDelete()
    props.deleteDocTypeAll()
    setIsStateDelete(false)
  }
  function undoDelete(){
    setIsStateDelete(false)
    clearIntervalAlert()
  }
  function closeAlert(){
    setIsStateDelete(false)
    // confirm Remove
    confirmRemove()
    clearIntervalAlert()
  }

  function callApiDelete() {

    let body = JSON.stringify({
      "claim_id": props.claim_id,
    })

    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Content-Type':'application/json'
      },
      body: body
    };
    fetch(api.objectStorage.deleteDoc(),requestOptions)
    .then(response => response.json())
    .then(data => onSuccessCallApiDelete(data), (error) => {
      if (error) {
        onFailCallApiDelete( error )
      }
    });
  }

  function onSuccessCallApiDelete( data ){
  }
  function onFailCallApiDelete( error ){

  }

  const getPreviewImage = (id, icon) => {
    if(isHasFile(id)) {
      const image = getFileListFirst(id) 
      if (
        image.toString().toLowerCase().indexOf('.png') >= 0 ||
        image.toString().toLowerCase().indexOf('.jpg') >= 0 ||
        image.toString().toLowerCase().indexOf('.heic') >= 0  ||
        image.toString().toLowerCase().indexOf('.heif') >= 0 
      ) {
        return image
      }
      return icon
    }
    
    return icon
  }

  function calculatetotalCost(){
    const temporaryLaborCost = laborCost == '' ? 0:laborCost
    const temporaryAutoParts = autoParts == '' ? 0:autoParts
    const temporaryLossOfBenefit = lossOfBenefit == '' ? 0:lossOfBenefit
    const temporaryTowCar = towCar == '' ? 0:towCar
    
    return Number(numeral(temporaryLaborCost).add(temporaryAutoParts).add(temporaryLossOfBenefit).add(temporaryTowCar).value()).toFixed(2)
  }

  function clearDemandedPrice(){
    setIsShowLaborCost(false)
    setIsShowAutoParts(false)
    setIsShowLossOfBenefit(false)
    setIsShowTowCar(false)
    setLaborCost(0.00)
    setAutoParts(0.00)
    setLossOfBenefit(0.00)
    setTowCar(0.00)

    setTotalCost(calculatetotalCost())
  }


  function onChangeNumber( value, setterInput ){
    if(value == undefined){
      setterInput(0.00)
    }else{
      setterInput(value)
    }
  }

  function onClickNumber( value, valueState, setterInput ){
    if(parseInt(valueState) == 0){
      value.target.value = ''
      setterInput('')    
    }
  }

  function onBlurNumber( value, valueState, setterInput ){
    if(value.target.value == ''){
      value.target.value = 0.00
      setterInput(0.00)    
    }
  }

  return (
    <div className=' flex-wrap w-full '>
      
          <div className="flex flex-wrap w-full justify-center p-0  ">

              <div className='flex flex-wrap w-[1092px] px-4 md:p-20 '>


                <div className=" flex flex-wrap w-full py-6 md:pt-0 md:pb-12  md:px-0">
                    
                    <ContactRefNo></ContactRefNo>

                    <div className='flex w-full'>
                      <span data-testid='pageTitle-label' className='w-full text-xl  md:text-2xl font-medium'>รายละเอียดการเรียกร้องค่าสินไหม</span>
                    </div>

                    <div className='flex-wrap w-full mt-6 '>
                      <div className='flex-wrap w-full md:w-[441px] mt-6 '>
                          <span className='flex-wrap w-full text-sm font-medium'>ประเภทการเรียกร้องค่าสินไหม<span className='text-red-500'>*</span></span>
                          <div className='flex w-full mt-1'>
                          {/* Dropdown */}
                            <div className=' flex-wrap w-full'>
                              <div className='w-full  h-[48px]  relative z-20 bg-white border-grey-300 border  rounded-lg font-prompt '>
                                <div
                                data-testid='claimType-dropdown' 
                                onClick={ (e) => { setIsShowDropDown(!isShowDropDown);   }}
                                className=' cursor-pointer w-full py-3.5 px-4 flex'>
                                  <div className='grow w-full'>
                                    <span className='text-base leading-5 font-normal'>{ CLAIM_TYPE(documentType+'') }</span>
                                  </div>
                                  <div className='flex-none my-auto'>
                                    <img src={iconDropDown} className='w-[16px] h-[16px]' alt='icon-dropdown-arrow' />
                                  </div>
                                </div>
                                <div className={
                                  ((isShowDropDown)? ' absolute ' : ' hidden ')+
                                  'w-full  bg-white  rounded-lg shadow-dropdown '}>
                                  <div className='w-full flex flex-wrap'>
                                    {
                                      claimTypeList.map(function(item, index){
                                        return (
                                          <div 
                                          onClick={ (e) => { 
                                            if(documentType != item.id){
                                              clearDemandedPrice();
                                            }
                                            setDocuentType(item.id); 
                                            setIsShowDropDown(!isShowDropDown); 
                                          }}
                                          className={
                                            ((index < claimTypeList.length-1 )? ' border-b ' : '')+
                                            ((index === 0 )? ' rounded-t-lg ' : '')+
                                            ((index === claimTypeList.length-1 )? ' rounded-b-lg ' : '')+
                                            ' w-full flex cursor-pointer border-grey-300  py-3 px-4 hover:bg-gray-100'}>
                                            <div className='grow w-full'>
                                              <span className='text-sm leading-5 font-normal' >{item.description}</span>
                                            </div>
                                            <div className='flex-none my-auto'>
                                              {
                              
                                                (item.id == documentType)?
                                                  <img alt='icon-dropdown-checked' src={iconDropDownChecked} className='w-[20px] h-[20px]' />
                                                :
                                                  null
                                              }
                                              
                                            </div>
                                          </div>  
                                        )
                                      })
                                    }
                                  </div>
                                
                                </div>
                              </div>
                            </div> 
                            {/* Dropdown */}
                          </div>
                          
                      </div>
                    </div>

                    { isShowLaborCost ? 
                      <div className='flex-wrap w-full md:w-[204px] mt-6 mr-[24px]'>
                        <span className=' text-black flex-wrap w-full text-sm font-medium'>ค่าแรง<span className='text-red-500'>*</span></span>
                        <div className='flex w-full mt-1'>
                          <div className=' flex-wrap w-full div-cost'>
                            <CurrencyInput
                              data-testid='price-labor-input'
                              disableAbbreviations={true}
                              allowNegativeValue={false}
                              placeholder=""
                              defaultValue={0.00}
                              value={laborCost}
                              decimalsLimit={2}
                              decimalScale={2}
                              onValueChange={(value, name) => {
                                  onChangeNumber(value,setLaborCost)
                                } 
                              }
                              onClick={(value) => {
                                  onClickNumber(value,laborCost,setLaborCost)
                                } 
                              }
                              onBlur={(value) => {
                                  onBlurNumber(value,laborCost,setLaborCost)
                                } 
                              }
                              className={'input-cost w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}
                            />
                            <span className={'span-cost text-[#ADADAD]'} >บาท</span>
                          </div> 
                        </div>
                      </div>
                      :
                      <></>  
                    }

                    { isShowAutoParts ? 
                      <div className='flex-wrap w-full md:w-[204px] mt-6 mr-[24px]'>
                        <span className=' text-black flex-wrap w-full text-sm font-medium'>ค่าอะไหล่<span className='text-red-500'>*</span></span>
                        <div className='flex w-full mt-1'>
                          <div className=' flex-wrap w-full  div-cost'>
                            <CurrencyInput
                              data-testid='price-autoPart-input'
                              disableAbbreviations={true}
                              allowNegativeValue={false}
                              placeholder=""
                              defaultValue={0.00}
                              value={autoParts}
                              decimalsLimit={2}
                              decimalScale={2}
                              onValueChange={(value, name) => {
                                  onChangeNumber(value,setAutoParts)
                                } 
                              }
                              onClick={(value) => {
                                  onClickNumber(value,autoParts,setAutoParts)
                                } 
                              }
                              onBlur={(value) => {
                                  onBlurNumber(value,autoParts,setAutoParts)
                                } 
                              }
                              className={'input-cost w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}
                            />
                            <span className={'span-cost text-[#ADADAD]'} >บาท</span>
                          </div> 
                        </div>
                      </div>
                      :
                      <></>  
                    }

                    { isShowLossOfBenefit ? 
                      <div className='flex-wrap w-full md:w-[204px] mt-6 mr-[24px]'>
                        <span className=' text-black flex-wrap w-full text-sm font-medium'>ค่าขาดผลประโยชน์<span className='text-red-500'>*</span></span>
                        <div className='flex w-full mt-1'>
                          <div className=' flex-wrap w-full div-cost'>
                            <CurrencyInput
                              data-testid='price-loseBenefits-input'
                              disableAbbreviations={true}
                              allowNegativeValue={false}
                              placeholder=""
                              defaultValue={0.00}
                              value={lossOfBenefit}
                              decimalsLimit={2}
                              decimalScale={2}
                              onValueChange={(value, name) => {
                                  onChangeNumber(value,setLossOfBenefit)
                                } 
                              }
                              onClick={(value) => {
                                  onClickNumber(value,lossOfBenefit,setLossOfBenefit)
                                } 
                              }
                              onBlur={(value) => {
                                  onBlurNumber(value,lossOfBenefit,setLossOfBenefit)
                                } 
                              }
                              className={'input-cost w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}
                            />
                            <span className={'span-cost text-[#ADADAD]'} >บาท</span>
                          </div> 
                        </div>
                      </div>
                      :
                      <></>  
                    }
                    
                    { isShowTowCar ? 
                      <div className='flex-wrap w-full md:w-[204px] mt-6 mr-[24px]'>
                        <span className=' text-black flex-wrap w-full text-sm font-medium'>ค่ารถยก<span className='text-red-500'>*</span></span>
                        <div className='flex w-full mt-1'>
                          <div className=' flex-wrap w-full div-cost'>
                            <CurrencyInput
                              data-testid='price-towCar-input'
                              disableAbbreviations={true}
                              allowNegativeValue={false}
                              placeholder=""
                              defaultValue={0.00}
                              value={towCar}
                              decimalsLimit={2}
                              decimalScale={2}
                              onValueChange={(value, name) => {
                                  onChangeNumber(value,setTowCar)
                                } 
                              }
                              onClick={(value) => {
                                  onClickNumber(value,towCar,setTowCar)
                                } 
                              }
                              onBlur={(value) => {
                                  onBlurNumber(value,towCar,setTowCar)
                                } 
                              }
                              className={'input-cost w-full h-[48px] font-prompt text-md border py-2 px-4 rounded-lg  ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}
                            />
                            <span className={'span-cost text-[#ADADAD]'} >บาท</span>
                          </div> 
                        </div>
                      </div>
                      :
                      <></>  
                    }

                    { isShowLaborCost || isShowAutoParts || isShowLossOfBenefit || isShowTowCar ? 
                      <div className='w-full mt-[24px]'>
                        <span className='w-full text-[16px]  text-[#666] font-normal'>รวมทั้งหมด</span><br/>
                        <span data-testid='price-total-text' className='w-full text-[14px]  text-[#000] font-normal'>{new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(totalCost).replace(/฿/,'') } <span> บาท</span></span>
                      </div>
                      :
                      <></> 
                    }

                    <div className='flex w-full mt-[48px]'>
                      <span className='w-full text-[14px]  text-[#004DFF] font-normal'>กรุณาอัปโหลดเอกสารที่มีเครื่องหมาย * ให้ครบถ้วนเพื่อสามารถพิจารณาคุมราคาได้ *</span>
                    </div>

                    <div className='flex flex-wrap w-full mt-6 md:mt-12 mb-12'>

                    {
                      fileList.map(function(item, index){
                        return (

                          <div
                            data-testid={testIdFileList[item.id]} 
                            className='flex w-1/2 sm:w-1/3 lg:w-1/4  px-[4px] md:px-3 py-[4px] md:py-3 justify-center'>
                            
    
                            <div 
                            className={((getHoverState(item.id))? ' cursor-pointer border-green-500 border-solid ' : ' border-grey-300 border-dashed ') + 'w-full  border  justify-center rounded-lg border-grey-300  h-[208px] md:h-[274px] ' + (isMobileSize ? 'px-[8px] ':'px-[12px]') } >
                                <div  onClick={(e) => { onClickFile( item.id ) }} className='flex flex-wrap w-full  justify-center  cursor-pointer'>
                                  
                                  <div className={((getHoverState(item.id) === false)? '  ' : ' hidden ')+' w-full flex-wrap'}>
                                    <div className={' flex-wrap w-full  '}>
                                      <div className={' flex justify-center '}>
    
                                        <div className='relative w-[72px] md:w-[112px] mt-[8px] md:mt-[24px] ' >
                                          <div className='flex w-full justify-center'>
                                            <img src={
                                                ( getPreviewImage(item.id, item.icon) )
                                              } alt="icon-upload" className='w-[72px] md:w-[112px] h-[72px] md:h-[112px]' />
                                          </div>
                                          {
                                            ( isHasFile(item.id) )?
                                              <div className='absolute bottom-0 right-0 w-[32px] h-[32px] md:w-[40px] md:h-[40px] rounded-full bg-green-500 justify-center flex' >
                                                <span className='text-lg leading-6 font-medium text-white my-auto'>{ getFileListSize(item.id) }</span>
                                              </div>
                                              :
                                              <img src={(item.is_required) ?  iconRequire : iconNotRequire } alt="icon-add" className='absolute bottom-0 right-0 w-[32px] h-[32px] md:w-[40px] md:h-[40px]' />
    
                                          }
                                        </div>
                                      </div>
                                      
                                      <div className='flex-wrap w-full md:mt-[16px]  mt-[4px]'>
                                        <span className='block w-full text-sm md:text-base md:leading-5 font-medium   text-center justify-center whitespace-pre'>{ (isMobileSize ? item.nameMobile:item.name) }
                                        {
                                            ( (item.is_required) )?
                                              <span className='text-red-500'>*</span>
                                              :
                                              <></>
                                        }
                                        </span>
                                        {
                                          (item.description !== "" && isMobileSize == false) ?
                                            <span className='block h-[32px] md:h-fit font-normal text-ellipsis overflow-hidden md:overflow-auto w-[180px] text-xs text-grey-600 text-center justify-center mt-[4px] whitespace-pre'>
                                             {item.description }
                                            </span>
                                          :
                                            null
                                        }
                                        {
                                          (item.description !== "" && isMobileSize) ?
                                            <span className='block  text-[12px]  h-[32px] md:h-fit font-normal text-ellipsis overflow-hidden md:overflow-auto w-100 text-xs text-grey-600 text-center justify-center mt-[4px] whitespace-pre'>  
                                             {item.descriptionMobile }
                                            </span>
                                          :
                                            null
                                        }
                                      </div>
                                    </div>
    
    
    
    
                                    <div className='flex w-full justify-center mt-[8px] md:mt-[8px]'>
                                      {
                                        (item.is_required === false )?
                                          <span className='px-2 py-0.5 mr-1 bg-gray-200 text-[10px] md:text-xs leading-3 font-normal text-grey-600 rounded text-center'>ไม่บังคับ</span>
                                          :
                                          null
                                      }
                                      {                                   
                                        (item.is_signatured === true )?
                                          (item.id === 8 ) ?
                                            <span className='px-1 py-0.5 ml-1  bg-green-200 text-[10px] md:text-xs leading-3 font-normal text-green-500 rounded  text-center'>พร้อมประทับตรา</span>
                                            :
                                            <span className='px-1 py-0.5 ml-1  bg-green-200 text-[10px] md:text-xs leading-3 font-normal text-green-500 rounded  text-center'>เซ็นสําเนาถูกต้อง</span>
                                          
                                          :
                                          null
                                      }
                                    </div>

                                    {(isHasFile(item.id)) ?  
                                    <div className='flex w-full justify-center mt-[8px] md:mt-[8px]'>
                                      <span className='px-0.5 py-0.5 ml-1  text-[10px] md:text-xs leading-3 font-normal text-[#004DFF] rounded  text-center'>อัปโหลดสำเร็จแล้ว</span>
                                    </div>
                                    :
                                    null
                                    }

                                  </div>

                                  {
                                    (getHoverState(item.id) === true)?
                                      <div className='flex-wrap w-full'>

                                        {
                                          (isHasFile(item.id))?

                                            <div className={' flex-wrap w-full  py-[92px] px-[12px] flex '}>
                                              <div className='flex-wrap w-full flex align-middle'>
                                                <div className='flex-wrap w-full  justify-center flex'>
                                                  <img src={iconFile} alt="icon-file" />
                                                </div>
                                                <div className='flex-wrap w-full mt-1 md:mt-[11px]'>
                                                  <span className='flex w-full text-sm  text-center justify-center'>เอกสารที่คุณอัพโหลด</span>
                                                  <span className='flex w-full md:mt-1 text-sm text-green-500 text-center justify-center '>ดูรายการ</span>
                                                </div>
                                              </div>
                                            </div>
                                            :
                                            <div className={' flex-wrap w-full py-[75px] px-[12px] flex '}>
                                              <div className='flex-wrap w-full  justify-center flex '>
                                                <img src={iconUpload} className='w-[22px] h-[20px]' alt="icon-file" />
                                              </div>
                                              <div className='flex-wrap w-full mt-1 md:mt-[12px]'>
                                                <span className='flex w-full text-sm  text-center justify-center'>ลากวางรูปที่คุณจะอัพโหลด</span>
                                                <span className='flex w-full md:mt-1 text-sm text-center justify-center text-grey-600 '>หรือ <span className='text-green-500 ml-1'>เลือกจากเครื่อง</span></span>
                                                <span className='flex w-full md:mt-1 text-xs text-grey-600 text-center justify-center '>PNG, JPG, PDF (สูงสุดไม่เกิน 10mb.)</span>
                                              </div>
                                            </div>
                                        }



                                  
                                      </div>
                                    : null
                                  }


    
                                </div>
    
                            </div>
                            
                  
                          </div>
                        )
                      })
                    }




                    </div>
                </div>

              </div>

              <div className='flex-wrap flex w-full mt-6 md:mt-20  md:h-80px md:justify-center  bg-white border-t-[0.5px] border-grey-500 fixed bottom-0 right-0'>
                <div className='flex flex-wrap w-full md:w-[1092px] md:justify-end '>
                  <div className='flex flex-wrap w-1/2 pr-2 justify-start'>
                    <button 
                        data-testid='clear-button'
                        onClick={ showAlert }
                        className={'w-full mt-[16px] mb-[16px] ml-[16px] md:w-[160px] lg:px-4 text-base leading-6 h-[48px] border border-grey-300  md:h-12 font-medium rounded-lg border-radius-other bg-white text-black '}>
                          เคลียร์ข้อมูล
                    </button>
                  </div>
                  <div className='flex flex-wrap w-1/2 pl-2 justify-end  '>
                    <button 
                        data-testid='next-button'
                        onClick={submit}
                        disabled={ (isEnableNewStep)? '':'disabled'}
                        className={'w-full mt-[16px] mb-[16px] mr-[16px] md:w-[160px] lg:px-4 text-base leading-6 h-[48px]  md:h-12 font-medium rounded-lg border-radius-other  '+ ( (isEnableNewStep)? ' bg-green-500 text-white ' : ' bg-grey-100 text-white ')}>
                          ต่อไป
                    </button>
                  </div>
                </div>
              </div>

          

              <div className={((isShowAlert)? ' fixed ' : ' hidden ' )+ ' flex bottom-0 inset-x-0 mx-auto shadow-alert border border-white  w-[360px] h-[40px] py-[10px] px-[12px] mb-[30px] bg-white rounded-lg '}>

                <div className='flex w-full'>
                  <div className='grow w-full flex-wrap flex'>
                    <img src={iconSuccessAlert} alt="icon-warning-alert" className='w-[16px] h-[16px] mr-[8px] my-auto' />
                    <span data-testid='toast-description-text' className='text-sm not-italic font-normal  my-auto w-[240px] truncate' >ลบรายการทั้งหมด</span>
                  </div>
                  <div className='flex-none flex-wrap flex'>
                      <span onClick={(e) => { undoDelete() }} className=' cursor-pointer text-sm not-italic font-medium text-green-500  my-auto' >เลิกทำ</span>
                      <button onClick={(e) => { closeAlert() }}><img src={iconCloseAlert} alt="icon-close-alert " className='w-[16px] h-[16px] ml-[8px] my-auto' /></button>
                  </div>
                </div>

              </div>
          </div>
    </div>
  )
}


const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => {
  return {
    updateClaimType : (payload) =>  dispatch(updateClaimType(payload)),
    deleteDocTypeAll : () =>   dispatch(deleteDocTypeAll()),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step2);